import * as React from "react";
import { Theme, TooltipProps } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import { toolTipZIndex } from "fe-common/ui/stacking";

//endregion [[ Styles ]]

//region [[ Functions ]]

export function AgentTooltip(props: TooltipProps) {
  const useStylesBootstrap = makeStyles((theme?: Theme) => ({
    popper: {
      zIndex: toolTipZIndex + 1,
    },
    arrow: {
      color: theme.palette.common.white,
      "&::before": {
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 5px",
      },
    },
    tooltip: {
      backgroundColor: theme.palette.common.white,
      fontSize: "14px",
      padding: "10px",
      color: KahunColorMap.Default,
      border: "1px solid rgb(235, 235, 235)",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px",
    },
  }));

  const classes = useStylesBootstrap();
  return <Tooltip arrow classes={classes} {...props} placement={"top"} />;
}
